import { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { HEFFALUMP, OLAF, GREAT_WHITE, BATTLESHIP } from 'HubStyleTokens/colors';
import UIList from 'UIComponents/list/UIList';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { FLOATY, PUSHY, COLLAPSED, TOGGLED_ANIMATION_DURATION, PANEL } from '../EPConstants';
import FadingVeil from './FadingVeil';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'reac... Remove this comment to see the full error message
import { CSSTransitionGroup } from 'react-transition-group';
import { getPatagoniaPanelAnimationType, easeInOutSine, computeUpdatedWidth } from '../utils/animationUtils';
import { getPanelFromSidebarOptions } from '../utils/sidebarUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DEFAULT_EXPANDED_WIDTH = 567;
const getWidthForPanel = (sidebarOptions, panelName) => {
  if (!panelName) {
    return 0;
  }
  const panel = getPanelFromSidebarOptions(sidebarOptions, panelName);
  return panel ? panel.contentWidth : 0;
};
const getIsPanelEmpty = panel => panel === '';
const Sidebar = styled.div.withConfig({
  displayName: "EPSideToolbar__Sidebar",
  componentId: "sc-1nxuqvb-0"
})(["position:relative;height:100%;min-width:52px;border-right:1px solid ", ";z-index:5;background:", ";display:flex;"], GREAT_WHITE, props => props.collapsed || props.panelType === PUSHY ? OLAF : 'rgba(255, 255, 255, 0.95)');
const SidebarContent = styled.div.withConfig({
  displayName: "EPSideToolbar__SidebarContent",
  componentId: "sc-1nxuqvb-1"
})(["position:", ";height:100%;overflow-y:", ";overflow-x:hidden;z-index:", ";border-left:", ";border-right:", ";background:", ";"], props => props.panelType === FLOATY || props.panelType === COLLAPSED ? 'absolute' : 'relative', props => props.showScroll ? 'auto' : 'hidden', props => props.panelType === FLOATY ? '6' : '4', props => props.collapsed ? '' : `1px solid ${GREAT_WHITE}`, props => props.collapsed ? '' : `1px solid ${GREAT_WHITE}`, props => props.panelType === COLLAPSED || props.panelType === PUSHY ? OLAF : 'rgba(255, 255, 255, 0.95)');
const IconWrapper = styled.div.withConfig({
  displayName: "EPSideToolbar__IconWrapper",
  componentId: "sc-1nxuqvb-2"
})(["padding-bottom:10px;.epSidebarIcon{padding:6px 8px 6px;font-size:23px;}"]);
const SidebarMenuSeparator = styled.div.withConfig({
  displayName: "EPSideToolbar__SidebarMenuSeparator",
  componentId: "sc-1nxuqvb-3"
})(["border:1px solid ", ";margin:0px 4px 0px 4px;margin-bottom:10px;"], BATTLESHIP);
class EPSideToolbar extends Component {
  constructor(props) {
    super(props);
    this.handlePanelTransition = () => {
      this.setState({
        panelInTransition: true
      });
      setTimeout(() => {
        const {
          onContentShown
        } = this.props;
        this.setState({
          panelInTransition: false
        });
        if (onContentShown) {
          onContentShown();
        }
      }, TOGGLED_ANIMATION_DURATION);
    };
    this.onAnimationFrame = newWidth => {
      const {
        onToggleAnimationFrame
      } = this.props;
      if (onToggleAnimationFrame) onToggleAnimationFrame(newWidth, this.animationType);
    };
    this.customToggleAnimation = timestamp => {
      if (!this.sidebarDomNode) {
        return;
      }
      if (!this.animationFrameStart) {
        this.animationFrameStart = timestamp;
      }
      const ratioAnimationComplete = (timestamp - this.animationFrameStart) / TOGGLED_ANIMATION_DURATION;
      if (ratioAnimationComplete < 1) {
        const easingCoefficient = easeInOutSine(ratioAnimationComplete);
        const newSidebarWidth = computeUpdatedWidth(easingCoefficient, this.startSidebarWidth, this.finalSidebarWidth);
        this.sidebarDomNode.style.width = `${newSidebarWidth}px`;
        this.onAnimationFrame(newSidebarWidth);
        this.requestAnimationFrameId = requestAnimationFrame(this.customToggleAnimation);
      } else {
        this.sidebarDomNode.style.width = `${this.finalSidebarWidth}px`;
        this.onAnimationFrame(this.finalSidebarWidth);
        this.handleToggleAnimationEnd();
        this.clearAnimationParameters();
      }
    };
    this.handleToggleAnimationEnd = () => {
      const {
        onToggleAnimationEnd
      } = this.props;
      if (onToggleAnimationEnd) onToggleAnimationEnd();
    };
    this.initSidebarDomNode = () => {
      if (!this.sidebarDomNode) {
        this.sidebarDomNode = this.sidebarRef;
      }
    };
    this.setupToggleAnimationParameters = (finalWidth, previousPanelType, nextPanelType) => {
      if (!this.sidebarRef) {
        return;
      }
      const sidebarRect = this.sidebarRef.getBoundingClientRect();
      if (this.props.onToggleAnimationStart) {
        this.props.onToggleAnimationStart();
      }
      this.initSidebarDomNode();
      this.startSidebarWidth = sidebarRect.width;
      this.finalSidebarWidth = finalWidth;
      this.animationType = getPatagoniaPanelAnimationType(previousPanelType, nextPanelType);
    };
    this.setupWidthAnimationParameters = finalWidth => {
      if (this.sidebarRef) {
        const sidebarRect = this.sidebarRef.getBoundingClientRect();
        const sidebarWidth = sidebarRect.width;
        if (this.props.onWidthAnimationStart) {
          this.props.onWidthAnimationStart(sidebarWidth);
        }
        this.initSidebarDomNode();
        this.startSidebarWidth = sidebarWidth;
        this.finalSidebarWidth = finalWidth;
      }
    };
    this.clearAnimationParameters = () => {
      this.animationFrameStart = null;
      this.startSidebarWidth = 0;
      this.finalSidebarWidth = 0;
      this.requestAnimationFrameId = null;
      this.animationType = null;
    };
    this.collapseSideToolbarPanel = previousPanel => {
      this.setupToggleAnimationParameters(0, this.getPanelType(previousPanel), COLLAPSED);
      if (this.requestAnimationFrameId) {
        cancelAnimationFrame(this.requestAnimationFrameId);
      }
      this.requestAnimationFrameId = requestAnimationFrame(this.customToggleAnimation);
    };
    this.openToSideToolbarPanel = (previousPanel, nextPanel) => {
      const {
        sidebarOptions
      } = this.props;
      const nextActivePanel = getPanelFromSidebarOptions(sidebarOptions, nextPanel);
      if (nextActivePanel) {
        this.setupToggleAnimationParameters(nextActivePanel.contentWidth, this.getPanelType(previousPanel), nextActivePanel.panelDisplay.type);
        if (this.requestAnimationFrameId) {
          cancelAnimationFrame(this.requestAnimationFrameId);
        }
        this.requestAnimationFrameId = requestAnimationFrame(this.customToggleAnimation);
      }
    };
    this.renderWhiteVeilAndContent = content => {
      const {
        panelInTransition
      } = this.state;
      const {
        sidebarContentClassName
      } = this.props;
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(CSSTransitionGroup, {
          transitionName: "white-veil",
          transitionAppear: true,
          transitionEnter: true,
          transitionLeave: true,
          transitionAppearTimeout: 100,
          transitionEnterTimeout: 100,
          transitionLeaveTimeout: 250,
          component: "div",
          children: panelInTransition && /*#__PURE__*/_jsx(FadingVeil, {}, 'white-veil-animation')
        }), /*#__PURE__*/_jsx("div", {
          style: {
            visibility: panelInTransition ? 'hidden' : 'visible',
            height: '100%'
          },
          className: sidebarContentClassName,
          children: content
        })]
      });
    };
    this.updateActivePanel = panelName => {
      const {
        handlePanelChange
      } = this.props;
      handlePanelChange(panelName);
    };
    this.handleSidebarButton = panelName => {
      const {
        collapsed,
        onExpand,
        onCollapse,
        activePanel
      } = this.props;
      if (collapsed) {
        this.updateActivePanel(panelName);
        this.openToSideToolbarPanel('', panelName);
        onExpand();
      } else {
        if (panelName === activePanel) {
          onCollapse();
          this.collapseSideToolbarPanel(activePanel);
          this.updateActivePanel('');
        } else {
          this.openToSideToolbarPanel(activePanel, panelName);
          this.updateActivePanel(panelName);
        }
      }
    };
    this.renderIcons = () => {
      const {
        sidebarOptions,
        collapsed,
        activePanel
      } = this.props;
      return sidebarOptions.map((option, index) => {
        if (option.type === PANEL) {
          if (option.hideItem) {
            return null;
          }
          const iconName = option.iconName;
          const buttonIsActive = option.panelName === activePanel;
          const tooltipLabel = option.tooltipLabel;
          const disabled = Boolean(option.disabled);
          return /*#__PURE__*/_jsx(IconWrapper, {
            children: /*#__PURE__*/_jsx(UITooltip, {
              placement: "right",
              title: tooltipLabel,
              children: /*#__PURE__*/_jsx(UIIconButton, {
                use: "link",
                className: "m-y-2",
                onClick: () => this.handleSidebarButton(option.panelName),
                disabled: disabled,
                "data-sidebar-button-id": option.panelName,
                "data-onboarding": `ep-side-toolbar-${option.panelName}`,
                "data-campaign-assistant-onboarding-tour": `tour-step-${option.panelName}`,
                style: {
                  padding: '6px 8px 6px',
                  backgroundColor: buttonIsActive && !collapsed ? HEFFALUMP : '',
                  color: buttonIsActive && !collapsed ? OLAF : HEFFALUMP,
                  fontSize: '23px'
                },
                children: /*#__PURE__*/_jsx(UIIcon, {
                  name: iconName
                })
              })
            })
          }, `epSideToolbarIcon-${index}`);
        } else {
          return /*#__PURE__*/_jsx(SidebarMenuSeparator, {}, index);
        }
      });
    };
    this.renderNavBar = () => {
      return /*#__PURE__*/_jsx("div", {
        style: {
          marginLeft: '6px',
          marginRight: '6px',
          width: '39px'
        },
        className: "nav-bar",
        "data-test-id": "ep-sidetoolbar-nav-items",
        children: /*#__PURE__*/_jsx(UIList, {
          children: this.renderIcons()
        })
      });
    };
    this.panelToRender = () => {
      const {
        sidebarOptions,
        activePanel
      } = this.props;
      const DEFAULT_PANEL = {
        content: '',
        contentWidth: 0,
        panelDisplay: {
          type: COLLAPSED,
          showScroll: false
        }
      };
      const panelToRender = getPanelFromSidebarOptions(sidebarOptions, activePanel);
      return panelToRender || DEFAULT_PANEL;
    };
    this.renderSidebarContent = () => {
      const {
        activePanel
      } = this.props;
      if (!activePanel) {
        return null;
      }
      return this.renderWhiteVeilAndContent(this.panelToRender().content);
    };
    this.state = {
      panelInTransition: false
    };
    this.sidebarDomNode = null;
    this.animationFrameStart = null;
    this.startSidebarWidth = 0;
    this.finalSidebarWidth = 0;
    this.requestAnimationFrameId = null;
    this.animationType = null;
    this.sidebarRef = null;
    this.customWidthAnimation = this.customWidthAnimation.bind(this);
  }
  componentDidMount() {
    this.initSidebarDomNode();
    if (!this.sidebarDomNode) {
      return;
    }
    const sidebarRefInlineWidth = this.sidebarDomNode.style.width;
    const currentPanel = this.panelToRender();
    const currentExpectedWidth = currentPanel.contentWidth;

    // Ensure our inline styles are set for the first time the sidebar is toggled
    if (sidebarRefInlineWidth === '') {
      // Use requestAnimationFrame to make sure we aren't triggering any reflows
      window.requestAnimationFrame(() => {
        if (this.sidebarDomNode) {
          this.sidebarDomNode.style.width = `${currentExpectedWidth}px`;
        }
      });
    }
  }
  componentDidUpdate(prevProps) {
    const {
      activePanel: currentActivePanel,
      sidebarOptions
    } = this.props;
    const previousActivePanel = prevProps.activePanel;
    const currentPanelIsEmpty = getIsPanelEmpty(currentActivePanel);
    const activePanelHasChanged = previousActivePanel !== currentActivePanel;
    if (activePanelHasChanged) {
      this.handlePanelTransition();
      if (currentPanelIsEmpty) {
        this.collapseSideToolbarPanel(previousActivePanel);
      } else {
        this.openToSideToolbarPanel(previousActivePanel, currentActivePanel);
      }
    } else if (!currentPanelIsEmpty && getWidthForPanel(sidebarOptions, currentActivePanel) !== getWidthForPanel(prevProps.sidebarOptions, previousActivePanel)) {
      this.animateActivePanelWidth(getWidthForPanel(sidebarOptions, currentActivePanel));
    }
  }
  getPanelType(panelName) {
    const {
      sidebarOptions
    } = this.props;
    const panel = getPanelFromSidebarOptions(sidebarOptions, panelName);
    return panel ? panel.panelDisplay.type : COLLAPSED;
  }
  handleWidthAnimationEnd() {
    const {
      onWidthAnimationEnd
    } = this.props;
    if (onWidthAnimationEnd) onWidthAnimationEnd();
  }
  onWidthAnimationFrame(easingCoefficient) {
    const {
      onWidthAnimationFrame
    } = this.props;
    if (onWidthAnimationFrame) onWidthAnimationFrame(easingCoefficient);
  }
  customWidthAnimation(timestamp) {
    if (!this.sidebarDomNode) {
      return;
    }
    if (!this.animationFrameStart) {
      this.animationFrameStart = timestamp;
    }
    const ratioAnimationComplete = (timestamp - this.animationFrameStart) / TOGGLED_ANIMATION_DURATION;
    if (ratioAnimationComplete < 1) {
      const easingCoefficient = easeInOutSine(ratioAnimationComplete);
      const newSidebarWidth = computeUpdatedWidth(easingCoefficient, this.startSidebarWidth, this.finalSidebarWidth);
      this.sidebarDomNode.style.width = `${newSidebarWidth}px`;
      this.onWidthAnimationFrame(easingCoefficient);
      this.requestAnimationFrameId = requestAnimationFrame(this.customWidthAnimation);
    } else {
      this.sidebarDomNode.style.width = `${this.finalSidebarWidth}px`;
      this.onWidthAnimationFrame(null);
      this.handleWidthAnimationEnd();
      this.clearAnimationParameters();
    }
  }
  animateActivePanelWidth(finalWidth) {
    this.setupWidthAnimationParameters(finalWidth);
    if (this.requestAnimationFrameId) {
      cancelAnimationFrame(this.requestAnimationFrameId);
    }
    this.requestAnimationFrameId = requestAnimationFrame(this.customWidthAnimation);
  }

  //sidebarOptions should be passed as for example see builder-demo-app's HomeContainer

  render() {
    const {
      collapsed,
      className
    } = this.props;
    const panelToRender = this.panelToRender();
    const panelType = panelToRender.panelDisplay.type;
    const expandedWidth = panelToRender.contentWidth;
    const showScroll = panelToRender.panelDisplay.showScroll;
    return /*#__PURE__*/_jsxs(Sidebar, {
      "data-test-id": "ep-sidetoolbar",
      panelType: panelType,
      collapsed: collapsed,
      className: className,
      children: [this.renderNavBar(), /*#__PURE__*/_jsx("div", {
        className: "sidebar-panel",
        children: /*#__PURE__*/_jsx(SidebarContent, {
          ref: ref => {
            this.sidebarRef = ref;
          },
          panelType: panelType,
          showScroll: showScroll,
          collapsed: collapsed,
          "data-test-id": "ep-sidetoolbar-content",
          "data-onboarding": "ep-sidetoolbar-content",
          "data-campaign-assistant-onboarding-tour": "tour-step-toolbar-content",
          "data-test-width": expandedWidth,
          children: this.renderSidebarContent()
        })
      })]
    });
  }
}
EPSideToolbar.propTypes = {
  collapsed: PropTypes.bool.isRequired,
  onExpand: PropTypes.func.isRequired,
  onCollapse: PropTypes.func.isRequired,
  sidebarOptions: PropTypes.array.isRequired,
  handlePanelChange: PropTypes.func.isRequired,
  activePanel: PropTypes.string.isRequired,
  className: PropTypes.string,
  sidebarContentClassName: PropTypes.string,
  onContentShown: PropTypes.func,
  onToggleAnimationFrame: PropTypes.func,
  onToggleAnimationEnd: PropTypes.func,
  onWidthAnimationEnd: PropTypes.func,
  onToggleAnimationStart: PropTypes.func,
  onWidthAnimationStart: PropTypes.func,
  onWidthAnimationFrame: PropTypes.func
};
EPSideToolbar.defaultProps = {
  expandedWidth: DEFAULT_EXPANDED_WIDTH
};
export default EPSideToolbar;